import { useState } from "react"

function BuscadorOC({ ordenes, value, onChange }) {
  const seleccionado = ordenes.find(o => String(o.id) === String(value)) || null
  const [query, setQuery]     = useState("")
  const [abierto, setAbierto] = useState(false)

  const filtrados = query.trim()
    ? ordenes.filter(o => {
        const q = query.toLowerCase()
        return (
          String(o.nroOrdenCompra ?? "").toLowerCase().includes(q) ||
          String(o.nroPedido      ?? "").toLowerCase().includes(q) ||
          o.paciente?.apellido?.toLowerCase().includes(q) ||
          o.paciente?.nombre?.toLowerCase().includes(q)
        )
      })
    : ordenes

  const placeholder = seleccionado
    ? `OC ${seleccionado.nroOrdenCompra} — ${seleccionado.paciente?.apellido}, ${seleccionado.paciente?.nombre}`
    : "n° OC, n° pedido o paciente..."

  const handleSelect = (o) => {
    onChange(o.id)
    setQuery("")
    setAbierto(false)
  }

  return (
    <div className="buscadorPaciente">
      <input
        type="text"
        placeholder={placeholder}
        value={query}
        onChange={e => {
          setQuery(e.target.value)
          setAbierto(true)
          if (!e.target.value) onChange("")
        }}
        onFocus={() => setAbierto(true)}
        onBlur={() => setAbierto(false)}
        style={{ width: 260 }}
      />
      {abierto && (
        <div className="buscadorPacienteDropdown">
          {filtrados.length === 0 ? (
            <div className="buscadorPacienteItem buscadorPacienteItem--vacio">sin resultados</div>
          ) : (
            filtrados.slice(0, 40).map(o => (
              <div
                key={o.id}
                className={`buscadorPacienteItem${String(o.id) === String(value) ? " buscadorPacienteItem--activo" : ""}`}
                onMouseDown={() => handleSelect(o)}
              >
                <span className="buscadorPacienteNombre">
                  OC {o.nroOrdenCompra} — {o.paciente?.apellido}, {o.paciente?.nombre}
                </span>
                <span className="buscadorPacienteInfo">
                  Pedido: {o.nroPedido || "—"} · {o.fEmision ? new Date(o.fEmision).toLocaleDateString("es-AR") : "—"}
                </span>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  )
}

export default BuscadorOC
